import styled from "styled-components";

export default styled.div`
    .button {
        margin-bottom: 20px;
    }
`;
